"use strict";
/*
 * Created on 10 05 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CRPFlag_1 = require("../../cleaning/model/CRPFlag");

var utils_1 = require("../../core/utils");

var CompetitorReferentialPrice_1 = require("../model/CompetitorReferentialPrice");

var CompetitorReferentialPriceState_1 = require("../model/CompetitorReferentialPriceState");

var CompetitorReferentialPriceConverter_1 = require("./CompetitorReferentialPriceConverter");
/**
 * @author Jaroslav Sevcik
 */


var CompetitorReferentialPriceConverterImpl =
/*#__PURE__*/
function (_CompetitorReferentia) {
  _inherits(CompetitorReferentialPriceConverterImpl, _CompetitorReferentia);

  function CompetitorReferentialPriceConverterImpl() {
    _classCallCheck(this, CompetitorReferentialPriceConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(CompetitorReferentialPriceConverterImpl).apply(this, arguments));
  }

  _createClass(CompetitorReferentialPriceConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new CompetitorReferentialPrice_1.CompetitorReferentialPrice(CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.id.valueOf(conversions.documentToClassId(source)), CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.priceZoneId.valueOf(conversions.toClassReferenceId(source.priceZoneId)), CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.competitorsProductId.valueOf(conversions.toClassReferenceId(source.competitorsProductId)), CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.competitorId.valueOf(conversions.toClassReferenceId(source.competitorId)), CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.date.valueOf(conversions.toDate(source.date)), CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.value.valueOf(conversions.toBigNumber(source.value)), CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.modifiedValue.valueOf(conversions.toBigNumber(source.modifiedValue)), CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.state.valueOf(conversions.asEnum(source.state, CompetitorReferentialPriceState_1.CompetitorReferentialPriceState)), utils_1.Utils.isValueMissing(source.promo) ? false : CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.promo.valueOf(source.promo), CompetitorReferentialPrice_1.CompetitorReferentialPrice.schema.lastPriceDate.valueOf(conversions.toDate(source.lastPriceDate)), conversions.asFlagSet(source.flags, CRPFlag_1.CRPFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        competitorsProductId: conversions.toDocumentReferenceId(source.competitorsProductId),
        competitorId: conversions.toDocumentReferenceId(source.competitorId),
        date: conversions.fromDate(source.date),
        value: conversions.fromBigNumber(source.value),
        modifiedValue: conversions.fromBigNumber(source.modifiedValue),
        state: source.state,
        promo: source.promo,
        lastPriceDate: conversions.fromDate(source.lastPriceDate),
        flags: source.flags.serialize()
      });
      return result;
    }
  }]);

  return CompetitorReferentialPriceConverterImpl;
}(CompetitorReferentialPriceConverter_1.CompetitorReferentialPriceConverter);

exports.CompetitorReferentialPriceConverterImpl = CompetitorReferentialPriceConverterImpl;